/**
 * Set the correct background image on the teaser element
 */

define('libs/teaser.backgroundimage',[],function() {

    'use strict';

    var SETTINGS = {
        highressize: 1300
    };

    var BackgroundImage = function($element, settings) {
        this.settings = $.extend({}, SETTINGS, settings || {});
        this.$root = $element;

        var defaultUrl = this.$root.data('bg'),
            highresUrl = this.$root.data('bg-highres');

        if (window.innerWidth >= this.settings.highressize && highresUrl) {
            this.setImage(highresUrl);
        } else {
            this.setImage(defaultUrl);
        }
    };

    /**
     * Set the image as background image.
     */
    BackgroundImage.prototype.setImage = function(url) {
        this.$root.css('background-image', 'url(' + url + ')');
    };

    return BackgroundImage;
});

